import { useState, useEffect } from "react";
import sanityClient from "../sanityClient";
import { tagsQuery } from "../queries/tagsQuery";
import { StandardLayout } from "../layouts/StandardLayout";
import { Link } from "react-router-dom";
import { sortTags } from "../util/sortTags";

export default function AllPosts() {
    const [tagsData, setTagsData] = useState(null);

    useEffect(() => {
        sanityClient
            .fetch(tagsQuery)
            .then((data) => setTagsData(data))
            .catch(console.error);
    }, []);

    let content = null;
    if (tagsData) {
        content = (
            <ul style={{ marginTop: "5px" }}>
                {sortTags(tagsData).map((tag) => (
                    <li key={tag.slug.current}>
                        <Link to={`/tags/${tag.slug.current}`}>{tag.title}</Link>
                    </li>
                ))}
            </ul>
        );
    } else {
        content = "Loading...";
    }

    return <StandardLayout title={"All Tags"} content={content} />;
}
